import {
  FontSchema,
  FontVariantSchema,
  OrganizationFontsSchema,
} from '../../definitions/schemas';
import {
  REGULAR_FONT_VARIANT,
  WebfontFamilySchema,
  WebfontList,
  WebfontVariant,
  WebfontVariantMap,
} from '../../Services/GoogleFonts/types';

export const getFontVariantName = (weight?: string) =>
  weight ? WebfontVariantMap[weight as WebfontVariant] : 'Regular';

export const isFontVariantSupported = (variant: string) =>
  variant === REGULAR_FONT_VARIANT || Number.isInteger(+variant);

export const isFontVariantRegular = (variant: string) =>
  variant === REGULAR_FONT_VARIANT;

export const buildWebfontFromSchema = (
  font: FontSchema
): WebfontFamilySchema => {
  const variants: FontVariantSchema[] = [];
  if (font.weight) {
    variants.push({ name: '', value: font.weight });
  }

  return { family: font.family, standard: font.standard, variants };
};

export const buildOrganizationWebfontsFromSchema = (
  fonts: OrganizationFontsSchema
) => {
  const { body, headline } = fonts;

  const fontsToLoad: WebfontList = [];

  if (body) {
    fontsToLoad.push(buildWebfontFromSchema(body));
  }

  if (headline) {
    fontsToLoad.push(buildWebfontFromSchema(headline));
  }

  return fontsToLoad;
};
